var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LinkPush"},[_c('a',{attrs:{"href":_vm.data.link,"target":"_blank"}},[_c('p',[_vm._v(_vm._s(_vm.data.title))]),_c('i',{staticClass:"far fa-arrow-right"})])])}
var staticRenderFns = []

export { render, staticRenderFns }